import * as brokerActions from './brokerReducer';
import Axios from 'axios';
import { push } from 'react-router-redux';
import { toastr } from 'react-redux-toastr';
import queryString from '../../../helpers/queryString';
import handleErrorResponse from '../../../helpers/handleErrorResponse';
import { ADD_RESOURCE } from '../../layout/redux/breadcrumb';

const defaultIncludes = [
  'organisation',
  'users',
  'users.roles',
  'active_commissions',
  'active_commissions.product',
  'active_commissions.insurer',
  'sources',
  'sources.source_type',
  'sources.broker',
  'organisation.channel_access',
  'channel.theme',
  'primary_contacts',
  'primary_contacts.roles',
  'broker_category',
  'organisation.legal_entity_type',
  'channel',
  'channels',

  'channel.all_documents',
  'channel.products',
  'channel.contents.template',
  'channel.journey',
  'channel.theme',
  'default_product_urls',
  'organisation_channel_access',
];

// export function setPdf(brokerId, title, content) {
//   return {
//     type: actions.SET_PDF,
//     brokerId,
//     title,
//     content,
//   };
// }
//

// export function isApproving(status) {
//   return {
//     type: actions.IS_APPROVING,
//     status
//   }
// }
// const clearBroker = () =>  {
//   return {
//     type: brokerActions.CLEAR_BROKER,
//   };
// }

// const isApproving = (status) =>  {
//   return {
//     type: brokerActions.IS_APPROVING,
//     status,
//   };
// }

const isDeclining = (status) => {
  return {
    type: brokerActions.IS_DECLINING,
    status,
  };
};

const isDeactivating = (status) => {
  return {
    type: brokerActions.IS_DEACTIVATING,
    status,
  };
};

const isReactivating = (status) => {
  return {
    type: brokerActions.IS_REACTIVATING,
    status,
  };
};

const isActivating = (status) => {
  return {
    type: brokerActions.IS_ACTIVATING,
    status,
  };
};

// export function isSendingApproval(status) {
//   return {
//     type: actions.IS_SENDING_APPROVAL,
//     status,
//   };
// }

const clearBroker = () => {
  return {
    type: brokerActions.CLEAR_BROKER,
  };
};

const isSubmitting = (status) => {
  return {
    type: brokerActions.IS_SUBMITTING,
    status,
  };
};

const setBroker = (broker) => {
  return {
    type: brokerActions.SET_BROKER,
    data: broker,
  };
};

const getBroker = (id, includes = defaultIncludes) => {
  return (dispatch) => {
    let endpoint = `brokers/product-insurers/${id}${queryString(includes)}`;
    dispatch(isSubmitting(true));

    return Axios.get(endpoint).then((response) => {
      dispatch(setBroker(response.data));
      dispatch({
        type: ADD_RESOURCE,
        id: response.data.data.id,
        name: response.data.data.attributes.name,
      });
      dispatch(isSubmitting(false));
      return response.data;
    });
  };
};

const getEmailTemplates = () => {
  return () => {
    let endpoint = 'email-templates?&page[limit]=500';
    return Axios.get(endpoint)
      .then((response) => {
        const templatesForPolicyOverriddenContent = [
          'Purchase Email',
          'Quote Email',
          'Cancellation Email',
        ];
        const templatesForRenewalOverriddenContent = [
          'Renewal Invite Email',
          'Renewal Reminder Email',
          'Renewal Expiry Email',
        ];

        const policyEmails = response.data.data.filter((template) => {
          return templatesForPolicyOverriddenContent.includes(template.attributes.name);
        });
        const renewalEmails = response.data.data.filter((template) => {
          return templatesForRenewalOverriddenContent.includes(template.attributes.name);
        });

        return {
          policyEmails: policyEmails,
          renewalEmails: renewalEmails,
        };
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  };
};

const getLetterTemplates = () => {
  return () => {
    let endpoint = 'document-templates?&page[limit]=500';
    return Axios.get(endpoint)
      .then((response) => {
        const renewalTemplatesForOverriddenContent = ['Broker Renewal Letter'];
        const renewalLetters = response.data.data.filter((template) => {
          return renewalTemplatesForOverriddenContent.includes(template.attributes.name);
        });
        return {
          renewalLetters: renewalLetters,
        };
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  };
};

const getDefaultContactUs = () => {
  return () => {
    let endpoint =
      'contents?&filter[template.key]=contact-us&filter[channel_key]=jtc-whitelabel-b2c&page[limit]=500&include=template';
    return Axios.get(endpoint)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  };
};

const getDefaultPrivacyPage = (channelKey) => {
  return () => {
    let endpoint = `contents?&filter[template.key]=privacy-page&filter[channel_key]=${channelKey}&page[limit]=500&include=template`;
    return Axios.get(endpoint)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  };
};

const getDefaultFaqs = () => {
  return () => {
    let endpoint =
      'contents?&filter[template.key]=questions-page&filter[channel_key]=jtc-whitelabel-b2c&page[limit]=500&include=template';
    return Axios.get(endpoint)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  };
};

const getAllProducts = () => {
  return (dispatch) => {
    return Axios.get('products?page[limit]=500')
      .then((response) => {
        dispatch({
          type: brokerActions.SET_ALL_PRODUCTS,
          data: response.data,
        });
        return true;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  };
};
const updateBroker = (resource, brokerId, isTracking, includes = defaultIncludes) => {
  return (dispatch) => {
    dispatch(isSubmitting(true));
    let endpoint = 'brokers/' + brokerId;
    endpoint += queryString(includes);

    return Axios.patch(endpoint, resource)
      .then(() => {
        dispatch(isSubmitting(false));
        if (isTracking) {
          dispatch(push('/admin/tracking-links/' + brokerId));
        } else {
          dispatch(push('/admin/brokers/' + brokerId));
        }
        return true;
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'There was an error updating this broker');
      });
  };
};

const updateBrokerCommissions = (commissions, brokerId, isTracking) => {
  return (dispatch) => {
    dispatch(isSubmitting(true));
    let endpoint = 'brokers/' + brokerId + '/commissions';

    return Axios.put(endpoint, commissions)
      .then(() => {
        dispatch(isSubmitting(false));
        if (isTracking) {
          // dispatch(push('/admin/tracking-links/' + brokerId));
        } else {
          // dispatch(push('/admin/brokers/' + brokerId + '/commissions/edit'));
        }
        return true;
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'There was an error updating the broker commissions');
      });
  };
};

const deactivateBroker = (id) => {
  return (dispatch) => {
    dispatch(isDeactivating(true));
    return Axios.post('brokers/' + id + ':deactivate', {
      data: {
        metadata: {
          send_email: false,
        },
      },
    })
      .then(() => {
        dispatch(getBroker(id)).then(() => {
          toastr.success('Deactivated', 'The broker has now been deactivated');
          return true;
        });
        return true;
      })
      .catch((error) => {
        handleErrorResponse(error, 'There was an error deactivating this broker');
      })
      .finally(() => {
        dispatch(isDeactivating(false));
      });
  };
};

const reactivateBroker = (id) => {
  return (dispatch) => {
    dispatch(isReactivating(true));
    return Axios.post('brokers/' + id + ':reactivate', {
      data: {
        metadata: {
          send_email: false,
        },
      },
    })
      .then(() => {
        dispatch(getBroker(id)).then(() => {
          toastr.success('Reactivate', 'The broker has now been reactivated');
          return true;
        });
        return true;
      })
      .catch((error) => {
        handleErrorResponse(error, 'There was an error reactivating this broker');
      })
      .finally(() => {
        dispatch(isReactivating(false));
      });
  };
};

const activateBroker = (id) => {
  return (dispatch) => {
    dispatch(isActivating(true));
    return Axios.post('brokers/' + id + ':activate')
      .then(() => {
        dispatch(getBroker(id)).then(() => {
          toastr.success('Activated', 'The broker activated');
          return true;
        });
        return true;
      })
      .catch((error) => {
        handleErrorResponse(error, 'There was an error activating this broker');
      })
      .finally(() => {
        dispatch(isActivating(false));
      });
  };
};

const transferBroker = (values, application, resourceType) => {
  return () => {
    return Axios.post(resourceType + '/' + application.data.id + ':merge', values)
      .then(() => {
        toastr.success('Success', 'Broker has been transferred');
        return true;
      })
      .catch((error) => {
        handleErrorResponse(error, 'Failed to transfer to Broker');
      });
  };
};

const createContract = (values) => {
  return () => {
    return Axios.post('brokers/contracts', values)
      .then(() => {
        toastr.success('Success', 'Broker contract has been created');
        return true;
      })
      .catch((error) => {
        handleErrorResponse(error, 'Failed to create Broker contract');
      });
  };
};

const assignUserToBroker = (id, values) => {
  return () => {
    return Axios.post('brokers/' + id + ':add-user', values)
      .then(() => {
        toastr.success('Success', 'User has been successfully assigned to Broker');
        return true;
      })
      .catch((error) => {
        handleErrorResponse(error, 'Failed to assign User to Broker');
      });
  };
};

const addWhiteLabel = (id, values) => {
  return (dispatch) => {
    return Axios.post('brokers/' + id + ':add-whitelabel', values)
      .then(() => {
        toastr.success('Success', 'White label saved');
        return true;
      })
      .then(() => {
        dispatch(getBroker(id));
      })
      .catch((error) => {
        handleErrorResponse(error, 'Failed to save white label');
      });
  };
};

const setBrokerPrimaryContact = (brokerId, values) => {
  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.patch('broker-management/' + brokerId + '/set-primary-contact', values)
      .then(() => {
        toastr.success('Success', 'Primary Contact Saved');
        return true;
      })
      .then(() => {
        dispatch(getBroker(brokerId));
        dispatch(isSubmitting(false));
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'Failed to set Primary Contact');
      });
  };
};

const createWhiteLabel = (id, values) => {
  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.post(
      'whitelabel-management/broker/' + id + '/create-white-label',
      values,
    )
      .then(() => {
        dispatch(isSubmitting(false));
        toastr.success('Success', 'White label saved');
        return true;
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'Failed to save white label');
      });
  };
};

const createBrokerContent = (id, values) => {
  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.post(
      'whitelabel-management/broker/' + id + '/create-broker-content',
      values,
    )
      .then(() => {
        dispatch(isSubmitting(false));
        toastr.success('Success', 'White label saved');
        return true;
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'Failed to save white label');
      });
  };
};

export const actions = {
  clearBroker,
  //isApproving,
  isDeclining,
  isDeactivating,
  isReactivating,
  isSubmitting,
  getBroker,
  getAllProducts,
  updateBroker,
  updateBrokerCommissions,
  // declineBroker,
  activateBroker,
  deactivateBroker,
  reactivateBroker,
  transferBroker,
  createContract,
  assignUserToBroker,
  addWhiteLabel,
  setBrokerPrimaryContact,
  setBroker,
  getEmailTemplates,
  getLetterTemplates,
  createWhiteLabel,
  createBrokerContent,
  getDefaultContactUs,
  getDefaultPrivacyPage,
  getDefaultFaqs,
};
